import { message } from "antd";
import { AUTHENTICATE_VIEW_CONSTANT } from "../../../shared/utils/CommonConstants";
import { SESSION_CONSTANT } from "../../../shared/utils/SessionConstants";
import DeliverableService from "../../DeliverableView/services/DeliverableService";

interface SsoSessionBody {
  userId?: string | null;
  organizationId?: string | null;
}

export type SsoLoadResult = "loaded" | "unmatched" | "failed" | "skipped";

const deliverableService = new DeliverableService();

const writeEmptyIfAbsent = (): void => {
  if (localStorage.getItem(SESSION_CONSTANT.FEATURES_KEY) === null) {
    localStorage.setItem(SESSION_CONSTANT.FEATURES_KEY, "[]");
  }
};

export const loadSsoFeatures = async (response: Response): Promise<SsoLoadResult> => {
  let body: SsoSessionBody | null = null;
  try {
    body = (await response.json()) as SsoSessionBody;
  } catch {
    message.error(AUTHENTICATE_VIEW_CONSTANT.SSO_SESSION_REFRESH_FAILED_MESSAGE);
    return "skipped";
  }

  if (!body || body.userId === undefined) {
    return "skipped";
  }

  const { userId, organizationId } = body;
  if (!userId || !organizationId) {
    writeEmptyIfAbsent();
    return "unmatched";
  }

  try {
    const features = await deliverableService.getAllFeatues(userId, organizationId);
    localStorage.setItem(SESSION_CONSTANT.FEATURES_KEY, JSON.stringify(features));
    return "loaded";
  } catch {
    message.error(AUTHENTICATE_VIEW_CONSTANT.SSO_SESSION_REFRESH_FAILED_MESSAGE);
    writeEmptyIfAbsent();
    return "failed";
  }
};
